import { encode } from "base64-xor";
import { Buffer } from 'buffer'
globalThis.Buffer = Buffer

import { FINGERPRINT_CIPHER, FINGERPRINT_SIGNATURE, FINGERPRINT_VERSION } from "../config";

// Webgl detect
let gl = null;
let glDebug = null;
try {
    const canvas = document.createElement("canvas");
    gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    glDebug = gl.getExtension('WEBGL_debug_renderer_info');
} catch (e) { } // eslint-disable-line no-empty

// NavigatorProperties
const navigatorProperties = [];
try {
    for (const v in window.navigator) {
        navigatorProperties.push(v);
    }
} catch (e) { } // eslint-disable-line no-empty

export const encodeToken = v => encode(FINGERPRINT_SIGNATURE, encode(FINGERPRINT_CIPHER, JSON.stringify(v)).split("").reduce((acc, char) => char + acc, ""));

export const fingerprint = () => {
    try {
        const r = (f) => {
            try {
                const v = f();
                if (typeof v === 'undefined') {
                    return null;
                }
                return v;
            } catch (err) { } // eslint-disable-line no-empty
            return null;
        }

        const flags = {
            // V1
            ua: r(() => window.navigator.userAgent), // 1 - User agent
            pl: r(() => window.navigator.platform), // 2 - Platform
            ck: r(() => window.navigator.cookieEnabled), // 3 - Cookies enabled
            tzp: r(() => Intl.DateTimeFormat().resolvedOptions().timeZone), // 4 - Timezone
            tzo: r(() => new Date().getTimezoneOffset()), // 4 - Timezone offset
            lgs: r(() => navigator.languages.join(',')),  // 5 - Languages
            dnt: r(() => window.navigator.doNotTrack), // 9 - DNT
            nph: r(() => navigatorProperties.map(m => m.slice(0, 1)).join('')), // Properties of navigator
            bid: r(() => navigator.buildID), // 11 - build id
            pr: r(() => navigator.product), // 12 - product
            prs: r(() => navigator.productSub), // 13 Product sub
            vnd: r(() => navigator.vendor), // 14 - Vendor
            vnds: r(() => navigator.vendorSub), // 15 - Vendor sub
            hc: r(() => navigator.hardwareConcurrency), // 16 - hardwareConcurrency
            je: r(() => navigator.javaEnabled()), // 17 - Java enabled
            pdf: r(() => navigator.pdfViewerEnabled), // 17 - PDF viewer
            mem: r(() => navigator.deviceMemory), //18 device memory
            rs_cd: r(() => window.screen.colorDepth), // 22 - screen depth color
            glv: r(() => gl.getParameter(glDebug.UNMASKED_VENDOR_WEBGL)), //28 - Webgl vendor
            glr: r(() => gl.getParameter(glDebug.UNMASKED_RENDERER_WEBGL)), //29 - Webgl renderer
            key: r(() => window.key), // 47 - key

            // V2
            rs_h: r(() => window.screen.height), // 48 - Screen height
            rs_w: r(() => window.screen.width), // 49 - Screen width
            phe: r(() => !!window._phantom), // 50 - Phantom detection
            nm: r(() => !!window.__nightmare), // 51 Nightmare detection
            lg: r(() => navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || ""), // 52 - Main language
            ars_h: r(() => screen.availHeight), // 53 - Screen available height
            ars_w: r(() => screen.availWidth),// 54 - Screen available height
            str_ss: r(() => !!window.sessionStorage), // 55 - Session storage availability
            str_ls: r(() => !!window.localStorage),// 56 - Session storage availability
            str_idb: r(() => !!window.indexedDB),// 57 - IndexedDB availability (1/2)
            str_odb: r(() => !!window.openDatabase), // 58 - IndexedDB availability (2/2)
            mmt: r(() => [...(window.navigator.mimeTypes || [])].map(e => e.type)).join(';'),// 59 - Readable mime types
            eva: r(() => eval.toString().length), // 60 - Eval test,
            cvs: r(() => Boolean(document.createElement("canvas").getContext("2d"))), // 61 - Rendering test
            dcok: r(() => window.location.hostname), // 62 - Hostname
        }

        const values = {
            v: FINGERPRINT_VERSION,
            t: new Date().getTime(),
            d: Object.keys(flags).map(flag => flags[flag]),
        };

        const token = encodeToken(values);

        //console.log('FINGERPRINT', flags, values, token);

        return token;
    } catch (e) {
        console.log('👆 Fingerprint error', e)
        return 'null';
    }
}